<template>
    <div class="search">
        <div class="input">
            <input type="text" ref="search" :placeholder="$d('输入以搜索')" v-model="text"
                   @focus="focus = true"
                   @blur="focus = false"
                   @input="searching">
        </div>
        <div class="search-content" v-if="focus || hover" @mouseenter="hover = true" @mouseleave="hover = false">
            <el-tabs v-if="text" v-model="active">
                <el-tab-pane :label="$d('菜单导航')" name="nav">
                    <el-tree ref="tree" highlight-current
                             :data="result.nav"
                             node-key="menuCode"
                             :props="{ children: 'children' }"
                             :default-expand-all="true"
                             :expand-on-click-node="false"
                             @node-click="navClick">
                        <div class="label" slot-scope="{ node, data }">
                            <div v-html="data.menuNamePinyinHighLight || data.menuNamePinyin"></div>
                            <div v-html="data.menuNameHighLight || data.menuName"></div>
                        </div>
                    </el-tree>
                </el-tab-pane>
                <el-tab-pane :label="$d('物料查询')" name="second">
                    <el-empty :description="$d('暂未开放')"></el-empty>
                </el-tab-pane>
                <el-tab-pane :label="$d('单号查询')" name="third">
                    <el-empty :description="$d('暂未开放')"></el-empty>
                </el-tab-pane>
                <el-tab-pane :label="$d('记录查询')" name="fourth">
                    <el-empty :description="$d('暂未开放')"></el-empty>
                </el-tab-pane>
            </el-tabs>
            <el-empty v-else :description="$d('请输入您需要搜索的内容')+'...'"></el-empty>
        </div>
    </div>
</template>

<script>
export default {
    name: 'indexSearch',
    props: {
        navList: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            focus: false,
            hover: false,
            active: 'nav',
            text: '',
            result: {
                nav: []
            }
        }
    },
    methods: {
        focusSearch: function () {
            this.$refs.search.focus()
        },
        searching: function () {
            this.$set(this.result, 'nav', this.searchNav(this.navList, this.text))
        },
        searchNav: function (data, val) {
            const keywords = val.toUpperCase().trim().split(' ')

            return JSON.parse(JSON.stringify(data)).filter(function f (item) {
                const label = `${item.menuNamePinyin}${item.name}`

                for (let text of keywords) {
                    if (label.includes(text)) {
                        item.menuNameHighLight = item.name.replace(text, `<span>${text}</span>`)
                        item.menuNamePinyinHighLight = item.menuNamePinyin.replace(text, `<span>${text}</span>`)
                        return true
                    }
                }
                if (item.children) {
                    return (item.children = item.children.filter(f)).length
                }
            })
        },
        navClick: function (item) {
            if (item.menuType === 'C') {
                window.selectNav(item)
            }
        }
    },
    mounted () {
        window.focusSearch = this.focusSearch
    }
}
</script>

<style scoped>
.search {
    width: 500px;
    height: 30px;
    padding: 0 20px;
    position: relative;
}

.search > .input {
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background: #f3f3f3 url(../../assets/icon/search.svg) center right 10px / 14px no-repeat;
    overflow: hidden;
}

input {
    width: 100%;
    height: 100%;
    border: 0;
    padding: 0 30px 0 20px;
    background: none;
    outline: none;
}

.search-content {
    width: 460px;
    height: 600px;
    padding: 10px 20px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 0 10px 0 #382b89;
    animation: showSearch 300ms ease-in-out 1 forwards;
    position: absolute;
    top: 35px;
    right: 20px;
    opacity: 0;
}

@keyframes showSearch {
    from {
        top: 45px;
        opacity: 0;
    }
    to {
        top: 35px;
        opacity: 1;
    }
}
</style>
<style>
.search-content .el-tabs {
    height: 100%;
}

.search-content .el-tabs__content {
    height: calc(100% - 55px);
    overflow: auto;
}

.search-content .label {
    display: flex;
}

.search-content .label > div:first-child {
    margin-right: 10px;
}

.search-content .label span {
    background: yellow;
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/index/indexSearch.vue